import type { HeroResponse } from '@/network/hero.api';
import { apiPost } from '@/network/api-client';

export interface MerchantGearOfferItem {
  id: number;
  slot: string;
  formId: string;
  name: string;
  subtype: string;
  rarity: string;
  ilvl: number;
  basePrimary: number;
  primaryStat: number;
  statType: string;
  speedModifier: number;
  critChance: number;
  agilityBonus: number;
  setName?: string;
  specialEffect?: string;
  cost: number;
  offerId?: string;
}

export interface MerchantStockResponse {
  items: MerchantGearOfferItem[];
}

export async function fetchMerchantStock(
  body: { npcId: number; positionX: number; positionY: number },
  telegramId?: number,
): Promise<MerchantStockResponse> {
  const query = telegramId != null ? `?telegramId=${telegramId}` : '';
  return apiPost<MerchantStockResponse>(`/hero/npc-merchant-stock${query}`, body);
}

export async function buyTownMerchantGear(
  body: { npcId: number; positionX: number; positionY: number; offerIndex: number;offerId?:string;commandId?:string;expectedGoldCost?:number },
  telegramId?: number,
): Promise<HeroResponse> {
  const query = telegramId != null ? `?telegramId=${telegramId}` : '';
  return apiPost<HeroResponse>(`/hero/npc-buy-town-gear${query}`, body);
}

export type { NpcShopBundle } from '@/network/towns.api';
